import React from "react";
import { useTranslation } from "react-i18next";
import arrowIcon from "../../assets/arrow.svg";
import Button from "./Button";
import Lottie from "react-lottie";

const HeroReuse = ({
  Subtitle,
  Title,
  Description,
  ButtonText,
  imgUrl,
  descriptionhead,
  type,
  date,
  titleClass,
  boldHead,
  lottie,
}) => {
  const { t } = useTranslation();
  const options = {
    loop: true,
    autoplay: true,
    animationData: lottie,
  };

  return (
    <div className="w-full bg-[#FAF9FA] max-w-full mx-auto pt-5">
      <div className={`w-full lg:mx-auto ${lottie ? "lg:max-w-[1200px]": "lg:max-w-7xl"} `}>
        <div className="flex lg:items-center lg:justify-end max-sm:px-4 max-xl:px-6 lg:pb-8 max-lg:flex-col gap-[21px] sm:gap-10 lg:gap-[90px]">
          <div className="flex flex-col gap-4 lg:w-1/2 md:max-w-[640px] lg:max-w-[600px]">
            <span className="text-darkPurple text-sm font-bold">
              {Subtitle}
            </span>
            <div className="flex md:flex-col flex-wrap md:gap-0 gap-2">
              <h2
                className={`text-darkBlue lg:text-darkGray font-extrabold text-4xl sm:text-[40px] font-sans sm:leading-[48px] ${titleClass}`}
              >
                {t(Title)}
              </h2>
            </div>
            {type && (
              <div className="flex gap-4">
                {type.map((item) => (
                  <div className="border border-darkPurple text-darkPurple rounded-lg px-3 py-1">
                    {item}
                  </div>
                ))}
              </div>
            )}
            <div className="flex flex-col gap-1">
            <div className="text-darkGray/70 text-lg">
              {descriptionhead && (
                <span>
                  At <span className="font-semibold mr-1">RegTechFlow,</span>
                </span>
              )}
              {boldHead && (
                <span className="font-semibold mr-1">RegTechFlow </span>
              )}
              <span className="max-w-[600px] text-lg">{Description}</span>
            </div>
            {date && (
              <span className="text-darkBlue text-sm font-semibold">
                {date}
              </span>
            )}
            </div>
            {ButtonText && (
              <Button
                ButtonText={ButtonText}
                path="/book-demo"
                icon={arrowIcon}
              />
            )}
          </div>
            {lottie ? (
              <div className="bg-background rounded-lg flex justify-center items-center lg:w-[635px]">
                <div className="bg-background rounded-lg lg:py-4 flex justify-center items-center">
                  <Lottie style={{borderRadius:'16px', width:'100%', height:'100%'}} options={options} />
                </div>
              </div>
            ) : imgUrl ? (
              <div className="bg-background rounded-lg flex justify-center items-center lg:w-[541px]">
                <img
                  src={imgUrl}
                  alt="Preview"
                  width={541}
                  height={364}
                  className="rounded-xl"
                />
              </div>
            ) : (
              <div className="bg-[#F1EFF1]/40 rounded-xl w-full lg:w-[541px] h-[241px] sm:h-[484px] lg:h-[364px]"></div>
            )}
        </div>
      </div>
    </div>
  );
};

export { HeroReuse };
